export default async ({ commit, state, dispatch, rootGetters }) => {
    let defaultPrice = await rootGetters['settings/defaultPrice']

    await dispatch('setVideo', null, {root: false})

    let video = state.video

    commit('setPriceVideo', {
        value: Math.trunc(defaultPrice + video),
        coef: video
    })
}